import {
  SET_DRAG_AND_DROP_CONTEXT,
  INITIALIZE_DRAG_AND_DROP_CONTEXT,
} from '../actionTypes';

import {
  initializeDnDContext,
  addNewColumnToDnDContextSection,
} from '../../../containers/clientAdminTiles/utils/initializeDnDContext';

export const emptyBucketsDates = buckets => {
  const digests = Object.values(buckets)
    .map(bucket => bucket.digests)
    .map(digest => Object.keys(digest));

  return [].concat(...digests).filter(dates => dates.length > 0);
};

const initialState = {
  plan: {
    columns: {},
    groupedColumns: {},
    columnOrder: [],
    tiles: {},
    draggedToNewDigest: null,
  },
  active: {
    columns: {},
    groupedColumns: {},
    columnOrder: [],
    tiles: {},
    draggedToNewDigest: null,
  },
  archive: {
    columns: {},
    groupedColumns: {},
    columnOrder: [],
    tiles: {},
    draggedToNewDigest: null,
  },
  draft: {
    columns: {},
    groupedColumns: {},
    columnOrder: [],
    tiles: {},
    draggedToNewDigest: null,
  },
};

export default function(state = initialState, action) {
  switch (action.type) {
    case INITIALIZE_DRAG_AND_DROP_CONTEXT: {
      const { tiles, activeStatus, tilesPerRow, buckets } = action.payload;

      const tilesForPlan = tiles.plan.tiles.concat(tiles.user_submitted.tiles);
      const emptyBuckets = emptyBucketsDates(buckets);
      const planDndContext = initializeDnDContext(
        tilesForPlan,
        'plan',
        tilesPerRow,
      );
      const activeDndContext = initializeDnDContext(
        tiles.active.tiles,
        'active',
        tilesPerRow,
      );
      const archiveDndContext = initializeDnDContext(
        tiles.archive.tiles,
        'archive',
        tilesPerRow,
      );
      const draftDndContext = initializeDnDContext(
        tiles.draft.tiles,
        'draft',
        tilesPerRow,
      );

      const newPlanDndContext = emptyBuckets.reduce((acc, date) => {
        if (activeStatus === 'plan' && !acc.columns[date]) {
          return addNewColumnToDnDContextSection(acc, date);
        }
        return acc;
      }, planDndContext);

      return {
        plan: { ...newPlanDndContext },
        active: { ...activeDndContext },
        archive: { ...archiveDndContext },
        draft: { ...draftDndContext },
      };
    }
    case SET_DRAG_AND_DROP_CONTEXT: {
      const newContext = action.payload || {};
      return {
        ...state,
        ...newContext,
      };
    }
    default: {
      return state;
    }
  }
}
